import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
let ContactStateModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('boolean'), _dec4 = attr('boolean'), _dec5 = attr('boolean'), _dec6 = attr('number'), _dec7 = attr('number'), _dec8 = attr('number'), _dec9 = attr('number'), _dec0 = belongsTo('organization', {
  inverse: 'contact_states',
  async: false
}), _dec1 = attr('boolean', {
  defaultValue: false
}), _class = class ContactStateModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "status_name", _descriptor, this);
    _initializerDefineProperty(this, "status_color", _descriptor2, this);
    _initializerDefineProperty(this, "status_default", _descriptor3, this);
    _initializerDefineProperty(this, "is_editable", _descriptor4, this);
    _initializerDefineProperty(this, "is_deletable", _descriptor5, this);
    _initializerDefineProperty(this, "rank", _descriptor6, this);
    _initializerDefineProperty(this, "number", _descriptor7, this);
    _initializerDefineProperty(this, "total", _descriptor8, this);
    _initializerDefineProperty(this, "item_number", _descriptor9, this);
    _initializerDefineProperty(this, "organization", _descriptor0, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor1, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "status_name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "status_color", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "status_default", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "is_editable", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "is_deletable", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "rank", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "number", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "item_number", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "organization", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ContactStateModel as default };
//# sourceMappingURL=contact-state.js.map
